module.exports = __webpack_public_path__ + "assets/apprentice-ratio.png?5fb0a9379e57e18521b330b1ef13014c";